import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { filter } from "rxjs/operators";
import { SeoService } from "./SeoService.service";
import { seoRoutesData } from "./SeoConstants";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
  constructor(
    private seoService: SeoService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const routeData = seoRoutesData[this.router.url.split("#")[0]];
        console.log(this.router.url, routeData);
        this.seoService.setSeoData({
          title: routeData.title,
          description: routeData.description,
          canonicalUrl: location.href.split("#")[0],
        });
      });
  }
}
